import { render, staticRenderFns } from "./selectExams.vue?vue&type=template&id=2a324705"
import script from "./selectExams.vue?vue&type=script&lang=js"
export * from "./selectExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports